import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';

import { MediaQueryService } from '@core/breakpoints';

import { NavbarComponent } from '../navbar/navbar.component';

@Component({
  selector: 'shell-not-found',
  templateUrl: './not-found.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, NavbarComponent]
})
export class NotFoundComponent {
  private readonly mediaService = inject(MediaQueryService);

  public readonly isLg = toSignal(this.mediaService.mediaQuery('max', 'lg'));
}
